module.exports = __webpack_public_path__ + "media/images/area/experiences-1dee2cb85e127dfca4eac28556311620.jpg";